import useActiveNavigation from '@Guidelines/Shell/AppShell/Hooks/useActiveNavigation';
import settingsPanelSignal, {
	closeSettingsPanel,
	openSettingsPanelAt,
} from '@Guidelines/Shell/AppShell/Signals/settingsPanelSignal';
import { SETTINGS_SECTION_IDS } from '@UI/Routing/navigationMenu';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useSignalValue } from '@verclam/pulsar';

export type SettingsPanelMode = 'pinned' | 'overlay' | 'closed';

export type SettingsPanelState = {
	readonly mode: SettingsPanelMode;
	readonly open: () => void;
	readonly close: () => void;
};

/** `pinned` on a settings route, `overlay` while opened on the current navigation, `closed` otherwise. */
const useSettingsPanel = (): SettingsPanelState => {
	const { key } = useLocation();
	const activeNavigation = useActiveNavigation();
	const openedOn = useSignalValue(settingsPanelSignal);

	const isSettingsRoute =
		activeNavigation !== null && SETTINGS_SECTION_IDS.includes(activeNavigation.section.id);
	const mode: SettingsPanelMode = isSettingsRoute ? 'pinned' : openedOn === key ? 'overlay' : 'closed';

	const open = React.useCallback(() => {
		openSettingsPanelAt(key);
	}, [key]);

	return { mode, open, close: closeSettingsPanel };
};

export default useSettingsPanel;
